module.exports = __webpack_public_path__ + "static/media/ui-dashboard.2713178a.webp";